var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4286 7.90902H18.3857C18.0095 4.82581 15.2637 2.5 12 2.5C8.7363 2.5 5.99052 4.82581 5.61429 7.90902H5.57143C3.59898 7.90902 2 9.42971 2 11.3056C2 13.1814 3.59898 14.7021 5.57143 14.7021H7V8.58833C7 5.96212 9.23858 3.83315 12 3.83315C14.7614 3.83315 17 5.96212 17 8.58833V15.3814C16.999 16.6641 16.055 17.7714 14.7357 18.0375C14.3412 16.7217 12.9795 15.8901 11.5572 16.0964C10.135 16.3028 9.09587 17.4827 9.13183 18.8505C9.16778 20.2184 10.2676 21.3474 11.6989 21.4859C13.1302 21.6244 14.4466 20.7291 14.7714 19.3962C16.8659 19.1008 18.4197 17.3951 18.4286 15.3814V14.7021C20.401 14.7021 22 13.1814 22 11.3056C22 9.42971 20.401 7.90902 18.4286 7.90902Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42871 11.3055C3.42871 10.18 4.3881 9.26758 5.57157 9.26758V13.3434C4.3881 13.3434 3.42871 12.431 3.42871 11.3055H3.42871Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 20.1367C11.2109 20.1367 10.5713 19.5284 10.5713 18.7781C10.5713 18.0277 11.2109 17.4194 11.9999 17.4194C12.7888 17.4194 13.4284 18.0277 13.4284 18.7781C13.4284 19.5284 12.7888 20.1367 11.9999 20.1367Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4287 13.3434V9.26758C19.6122 9.26758 20.5716 10.18 20.5716 11.3055C20.5716 12.431 19.6122 13.3434 18.4287 13.3434H18.4287Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.b715588082af17b7af8fd0e5fd70a6a4.svg";
export { ForwardRef as ReactComponent };